import { render, staticRenderFns } from "./valuable-concepts-modal-relationships.vue?vue&type=template&id=798a4158&scoped=true&"
import script from "./valuable-concepts-modal-relationships.ts?vue&type=script&lang=ts&"
export * from "./valuable-concepts-modal-relationships.ts?vue&type=script&lang=ts&"
import style0 from "./valuable-concepts-modal-relationships.scss?vue&type=style&index=0&id=798a4158&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "798a4158",
  null
  
)

export default component.exports